import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "memory-item" }
const _hoisted_2 = { class: "item-actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_Popconfirm = _resolveComponent("Popconfirm")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Icon, {
      icon: "brain",
      class: "memory-icon",
      size: "2rem",
      stroke: "var(--gray-700)",
      "stroke-width": "1"
    }),
    _createVNode(_component_Ellipsis, { class: "text" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString($props.item.text), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Icon, {
        icon: "edit-03",
        class: "pointer",
        size: "2rem",
        stroke: "var(--gray-600)",
        "stroke-width": "1",
        disabled: $props.disabled,
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('edit', $props.item.index)), ["stop"]))
      }, null, 8 /* PROPS */, ["disabled"]),
      _createVNode(_component_Popconfirm, {
        width: "max-content",
        "confirm-button-text": "Yes",
        "cancel-button-text": "No",
        title: "Are you sure you want to delete this memory?",
        disabled: $props.disabled,
        onConfirm: _cache[1] || (_cache[1] = $event => (_ctx.$emit('delete', $props.item.index)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Icon, {
            icon: "trash-04",
            class: "pointer",
            size: "2rem",
            stroke: "var(--gray-600)",
            "stroke-width": "1",
            disabled: $props.disabled
          }, null, 8 /* PROPS */, ["disabled"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"])
    ])
  ]))
}